import React, { useCallback, useEffect, useRef, useState } from 'react';
import { useNotification } from '../../../hooks/useNotification';
import { useDataAuth } from '../../../hooks/useDataAuth';
import { useForm } from '../../../hooks/useForm';
import { useLocation, useNavigate } from 'react-router-dom';
import CardContent from '@mui/material/CardContent';
import Card from '@mui/material/Card';
import Box from '@mui/material/Box';

import { insertDataClient, updateClient } from "../../../services/client.service";  
import { fetchClientById, fetchClientOfficeId, getCompanies } from '../../../services/client.service';
import { DialogSelectCompany } from '../../../components/dialogs/DialogSelectCompany';
import { CreateFormClient } from '../../../components/client/CreateFormClient';
import { LocationClient } from '../../../components/client/LocationClient';
import { ActionButtons } from '../../../components/others/ActionButtons';
import LoadingOverlay from '../../../components/others/LoadingOverlay';

export const LayoutClient = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const [sendNotification] = useNotification();
    const [{ userSession }] = useDataAuth();
    const [companies, setCompanies] = useState([]);
    const [isView, setIsView] = useState(false);
    const [openDialogCompany, setOpenDialogCompany] = useState(false);
    const initialData = {
        id_company: "",
        type_identification: '',
        identification: '',
        last_name: '',
        identification_digit: '',
        business_name: '',
        email: '',
        supplier_tax_scheme: 'ZZ',
        supplier_tax_level_code: [],
        location: [],
        contacts:[],
        category: '',
        segment: '',
        additional_fields: '',
        additional_account_id:'',
        updated_by:userSession.username
    }

    const [values, handleInputChange, handleDirectInputChange, setAllInfo] = useForm(initialData);

    const createClientRef = useRef();
    const locationRef = useRef();

    const [loading, setLoading] = useState(false);
    const [isEdit, setIsEdit] = useState(false);


    const fetchClientData = useCallback(async (id) => {
        setIsEdit(true);
        setLoading(true);
        setOpenDialogCompany(false);
        try {
            const response_location = await fetchClientOfficeId(userSession.token, id);
            const response = await fetchClientById(userSession.token, id);
            if (response.status === 200) {
                const dto = response.data;
                dto.id_client = id;
                dto.location = response_location.status === 200 ? response_location.data || [] : [];
                dto.contacts = response.data.contacts ? response.data.contacts.split(',').filter(c => c) : [];;
                setAllInfo(dto);
            }
        } catch (e) {
            console.error("Error fetching data ", e);
        } finally {
            setLoading(false);
        }
    }, [userSession.token])



    useEffect(() => {
        if (location.state && location.state.config) {
            const { config } = location.state;
            if (config.data?.work_flow === 'FLOW_PROCESS-VIEW_CLIENT') {
                setIsView(true);
            }            
            if (config.data?.id) {
                fetchClientData(config.data?.id);
            } else {

                const fetchDataCompany = async () => {
                    try {
                        setLoading(true);
                        const response = await getCompanies('44', userSession.token);
                        setCompanies(response.data || []);
                        if (response.data && response.data.length === 1) {
                            const dto = response.data[0];
                            handleDirectInputChange("id_company",dto.id_company);
                            setOpenDialogCompany(false);
                        }
                        else
                            setOpenDialogCompany(true);
                    } catch (e) {
                        console.error(e.message);
                    } finally {
                        setLoading(false);
                    }
                }
                fetchDataCompany();
            }
        }
    }, [fetchClientData, location.state])


    const handleSubmit = (event) => {
        event.preventDefault();
        const isValidCreateClientRef = createClientRef.current?.validateForm();
        const data = JSON.stringify(values);
        if (isValidCreateClientRef) {
            if(isEdit) {
                updateClient(data, userSession.token);
                sendNotification({ msg: "Cliente actualizado exitosamente.", variant: "success"});
                Cancel();
            } else {
                insertDataClient(data, userSession.token);
                sendNotification({ msg: "Cliente creado exitosamente.", variant: "success", });
                Cancel();
            }
        } else {
            sendNotification({
                msg: "Por favor complete todos los campos requeridos",
                variant: "error",
            });
        }
    };


    const Cancel = () => {
        setOpenDialogCompany(false);
        navigate(-1)
    };

    const handleConfirmAction = useCallback(async (values) => {
        handleDirectInputChange('id_company', values.id_company);
        setOpenDialogCompany(false);
    }, []);

    return (
        <Box sx={{ mx: 'auto' }}>
            <Card sx={{ mb: 3 }}>
                <CardContent>
                    <CreateFormClient
                        ref={createClientRef}
                        dto={values}
                        handleInputChange={handleInputChange}
                        handleDirectInputChange={handleDirectInputChange}
                        isView={isView}
                    />

                    <Box sx={{ height: '5px', mt: 4, mb: 4, background: 'linear-gradient(to right, #6728AF 50%, #84858a 50%)' }}></Box>

                    <LocationClient
                        ref={locationRef}
                        dto={values}
                        isEdit={isEdit}
                        handleDirectInputChange={handleDirectInputChange}
                        isView={isView}
                    />

                    <ActionButtons
                        onCancel={Cancel}
                        onSubmit={handleSubmit}
                        disabledSubmit={isView}
                    />
                </CardContent>
            </Card>
            <DialogSelectCompany
                openDialogConfirm={openDialogCompany}
                handleCancelConfirm={Cancel}
                handleConfirmAction={handleConfirmAction}
                data={companies}
            />
            <LoadingOverlay isOpen={loading} />
        </Box>
    )
}